/* eslint-disable  */

export default {
  "About us": "About us",
  "Account": "Account",
  "Add new address": "Add new address",
  "Add to compare": "Add to compare",
  "Add to Wishlist": "Add to Wishlist",
  "Additional Information": "Additional Information",
  "All Orders": "All Orders",
  "Allow order notifications": "Allow order notifications",
  "Apply": "Apply",
  "Applied Coupon": "Applied Coupon",
  "Attention!": "Attention!",
  "Back to home": "Back to home",
  "Back to homepage": "Back to homepage",
  "Billing": "Billing",
  "Billing address": "Billing address",
  "Brand": "Brand",
  "Cancel": "Cancel",
  "Cart": "Cart",
  "Categories": "Categories",
  "Change": "Change",
  "Change password your account": "If you want to change the password to access your account, enter the following information",
  "Clear all": "Clear all",
  "Color": "Color",
  "Commercial information": "and agree to receive personalized commercial information from Brand name by email",
  "Contact details updated": "Keep your addresses and contact details updated.",
  "Continue to billing": "Continue to billing",
  "Continue to payment": "Continue to payment",
  "Continue to shipping": "Continue to shipping",
  "Cookies Policy": "Cookies Policy",
  "Create an account": "Create an account",
  "Customer Reviews": "Customer Reviews",
  "Customer service": "Customer service",
  "Date": "Date",
  "Default Billing Address": "Default Billing Address",
  "Default Shipping Address": "Default Shipping Address",
  "Delete": "Delete",
  "Departments": "Departments",
  "Description": "Description",
  "Details and status orders": "Check the details and status of your orders in the online store. You can also cancel your order or request a return.",
  "Discount": "Discount",
  "Done": "Done",
  "Download": "Download",
  "Download all": "Download all",
  "Edit": "Edit",
  "Email address": "电子邮箱地址",
  "Empty": "Looks like you haven’t added any items to the bag yet. Start shopping to fill it in.",
  "Empty bag": "Empty bag",
  "Enjoy your free account": "Enjoy these perks with your free account!",
  "Enter promo code": "Enter promo code",
  "Feedback": "Your feedback is important to us. Let us know what we could improve.",
  "Feel free to edit": "Feel free to edit any of your details below so your account is always up to date",
  "Filters": "Filters",
  "Find out more": "Find out more",
  "First Name": "First Name",
  "Forgot Password": "If you can’t remember your password, you can reset it.",
  "Forgot Password Modal Email": "Email you are using to sign in:",
  "forgotPasswordConfirmation": "Thanks! If there is an account registered with the {0} email, you will find message with a password reset link in your inbox.",
  "Forgotten password?": "Forgotten password?",
  "Go back": "Go back",
  "Go back shopping": "Go back shopping",
  "Go back to shop": "Go back to shop",
  "Go to checkout": "Go to checkout",
  "Go to cart": "Go to cart",
  "Guarantee": "Guarantee",
  "Help": "Help",
  "Help & FAQs": "Help & FAQs",
  "hide": "hide",
  "Home": "首页",
  "Bekaert Global": "贝卡尔特全球官网",
  "Bekaert Wire": "贝卡尔特中国弹簧钢丝",
  "Bekaert Japan": "贝卡尔特日本",
  "Bekaert Costa Rica, Central America & Caribbean": "贝卡尔特哥斯达黎加、中美洲和加勒比地区",
  "Bekaert Latin America": "贝卡尔特拉美",
  "Bekaert Fencing North America": "贝卡尔特北美栅栏",
  "Bekaert Construction North America": "贝卡尔特北美建筑",
  "I agree to": "I agree to",
  "I confirm subscription": "I confirm subscription",
  "I want to create an account": "I want to create an account",
  "Info after order": "You can log to your account using e-mail and password defined earlier. On your account you can edit your profile data, check history of transactions, edit subscription to newsletter.",
  "Instruction1": "Take care of me",
  "Instruction2": "Just here for the care instructions?",
  "Instruction3": "Yeah, we thought so",
  "It was not possible to request a new password, please check the entered email address.": "It was not possible to request a new password, please check the entered email address.",
  "Item": "Item",
  "Items": "Items",
  "Kidswear": "Kidswear",
  "Last Name": "Last Name",
  "Let’s start now – we’ll help you": "Let’s start now – we’ll help you.",
  "Log into your account": "Log into your account",
  "Login": "Login",
  "login in to your account": "login in to your account",
  "Looks like you haven’t added any items to the bag yet. Start shopping to fill it in.": "Looks like you haven’t added any items to the bag yet. Start shopping to fill it in.",
  "Looks like you haven’t added any items to the Wishlist.": "Looks like you haven’t added any items to the Wishlist.",
  "Make an order": "Make an order",
  "Manage addresses": "Manage all the addresses you want (work place, home address...) This way you won\"t have to enter the address manually with each order.",
  "Manage billing addresses": "Manage all the billing addresses you want (work place, home address...) This way you won\"t have to enter the billing address manually with each order.",
  "Manage shipping addresses": "Manage all the shipping addresses you want (work place, home address...) This way you won\"t have to enter the shipping address manually with each order.",
  "Match it with": "Match it with",
  "Men fashion": "Men fashion",
  "Menu": "Menu",
  "My billing and shipping address are the same": "My billing and shipping address are the same",
  "My Cart": "My Cart",
  "No account": "Don't have an account yet?",
  "or": "or",
  "or fill the details below": "or fill the details below",
  "Order ID": "Order ID",
  "Order information": "Order information",
  "Order No.": "Order No.",
  "Order summary": "Order summary",
  "Other products you might like": "Other products you might like",
  "Out of stock": "Out of stock",
  "Password": "Password",
  "Password Changed": "Password successfuly changed. You can now go back to homepage and sign in.",
  "Pay for order": "Pay for order",
  "Payment": "Payment",
  "Payment & Delivery": "Payment & Delivery",
  "Payment Method": "Payment Method",
  "Payment Methods": "Payment Methods",
  "Please type your current password to change your email address.": "Please type your current password to change your email address.",
  "Price": "Price",
  "Privacy": "Privacy",
  "Privacy Policy": "隐私政策",
  "Product": "Product",
  "Product suggestions": "Product suggestions",
  "Products": "Products",
  "Products found": "Products found",
  "Purchase terms": "Purchase terms",
  "Quality in the details": "Quality in the details",
  "Quantity": "Quantity",
  "Read all reviews": "Read all reviews",
  "Read and understand": "I have read and understand the",
  "Read reviews": "Read reviews",
  "Register": "Register",
  "Register today": "Register today",
  "Remove": "Remove",
  "Remove Address": "Remove Address",
  "Remove from Wishlist": "Remove from Wishlist",
  "Repeat Password": "Repeat Password",
  "Reset Password": "Reset Password",
  "Review my order": "Review my order",
  "Same as shipping address": "Same as shipping address",
  "Save changes": "Save changes",
  "Save for later": "Save for later",
  "Save Password": "Save Password",
  "Search": "搜索",
  "Search for items": "搜索项目",
  "Search results": "Search results",
  "Sections that interest you": "Sections that interest you",
  "See all results": "See all results",
  "See more": "See more",
  "Select payment method": "Select payment method",
  "Select shipping method": "Select shipping method",
  "Send my feedback": "Send my feedback",
  "Set up newsletter": "Set up your newsletter and we will send you information about new products and trends from the sections you selected every week.",
  "Share your look": "Share your look",
  "Shipping": "Shipping",
  "Shipping address": "Shipping address",
  "Shipping details": "Shipping details",
  "Shipping method": "Shipping method",
  "Show":"Show",
  "show more": "show more",
  "Show on page": "Show on page",
  "Sign in": "Sign in",
  "Size guide": "Size guide",
  "Sign Up for Newsletter": "Sign Up for Newsletter",
  "Sort by": "Sort by",
  "Sort: Default": "Default",
  "Sort: Name A-Z": "Name A-Z",
  "Sort: Name Z-A": "Name Z-A",
  "Sort: Price from high to low": "Price from high to low",
  "Sort: Price from low to high": "Price from low to high",
  "Start shopping": "Start shopping",
  "Status": "Status",
  "Subscribe": "订阅",
  "Subscribe to newsletter": "Subscribe to newsletter",
  "subscribeToNewsletterModalContent": "After signing up for the newsletter, you will receive special offers and messages from VSF via email. We will not sell or distribute your email to any third party at any time. Please see our {0}.",
  "Subtotal": "Subtotal",
  "Subtotal price": "Subtotal price",
  "Successful placed order": "You have successfully placed the order. You can check status of your order by using our delivery status feature. You will receive an order confirmation e-mail with details of your order and a link to track its progress.",
  "Terms and conditions": "Terms and conditions",
  "Thank you": "Thank you",
  "Thank You Inbox": "If the message is not arriving in your inbox, try another email address you might’ve used to register.",
  "Total": "Total",
  "Order Total": "Order Total",
  "Total items": "Total items",
  "Total price": "Total price",
  "Update password": "Update password",
  "Update personal data": "Update personal data",
  "Use your personal data": "At Brand name, we attach great importance to privacy issues and are committed to protecting the personal data of our users. Learn more about how we care and use your personal data in the",
  "User Account": "User Account",
  "View": "View",
  "View details": "View details",
  "Vue Storefront Next": "Vue Storefront Next",
  "Who we are": "Who we are",
  "Wishlist": "Wishlist",
  "Women fashion": "Women fashion",
  "You added {product} to your shopping cart.": "You added {product} to your shopping cart.",
  "You are not authorized, please log in": "You are not authorized, please log in",
  "You can unsubscribe at any time": "You can unsubscribe at any time",
  "You currently have no orders": "You currently have no orders",
  "You haven\’t searched for items yet": "You haven’t searched for items yet.",
  "Your bag is empty": "Your bag is empty",
  "Your current email address is": "Your current email address is",
  "Your email": "Your email",
  "The email field must be a valid email":"The email field must be a valid email",
  'You have submitted no reviews': 'You have submitted no reviews',
  "The account sign-in was incorrect or your account is disabled temporarily. Please wait and try again later.":"The account sign-in was incorrect or your account is disabled temporarily. Please wait and try again later.",
  "A customer with the same email address already exists in an associated website.": "A customer with the same email address already exists in an associated website.",
  "Invalid email": "无效的邮箱",
  "SUMMER COLLECTION {year}": "SUMMER COLLECTION {year}",
  "Colorful summer dresses are already in store": "Colorful summer dresses are already in store",
  "Learn more": "了解更多",
  "Dresses": "Dresses",
  "Cocktail & Party": "Cocktail & Party",
  "Linen Dresses": "Linen Dresses",
  "T-Shirts": "T-Shirts",
  "The office life": "The office life",
  "Find stunning women's cocktail dresses and party dresses. Stand out in lace and metallic cocktail dresses from all your favorite brands.": "Find stunning women's cocktail dresses and party dresses. Stand out in lace and metallic cocktail dresses from all your favorite brands.",
  "Shop now": "Shop now",
  "The Office Life": "The Office Life",
  "Summer Sandals": "Summer Sandals",
  "Eco Sandals": "Eco Sandals",
  "Subscribe to Newsletters": "Subscribe to Newsletters",
  "Be aware of upcoming sales and events. Receive gifts and special offers!": "Be aware of upcoming sales and events. Receive gifts and special offers",
  "Fashion to take away": "Fashion to take away",
  "Download our application to your mobile": "Download our application to your mobile",
  "Share Your Look": "Share Your Look",
  "My Account": "My Account",
  "My profile": "My profile",
  "Addresses details": "Addresses details",
  "My newsletter": "My newsletter",
  "Log out": "Log out",
  "My reviews": "My reviews",
  "Order history": "Order history",
  "Order details": "Order details",
  "My wishlist": "My wishlist",
  "Password change": "Password change",
  "Personal data": "Personal data",
  "Your e-mail": "Your e-mail",
  "Current Password": "Current Password",
  "You are not authorized, please log in.": "You are not authorized, please log in.",
  "Go To Product": "Go To Product",
  "Change to list view": "Change to list view",
  "Change to grid view": "Change to grid view",
  "Returns":"Returns",
  "My orders": "My orders",
  "Add the address": "Add the address",
  "Set as default shipping": "Set as default shipping",
  "Set as default billing": "Set as default billing",
  "House/Apartment number": "House/Apartment number",
  "Street Name": "Street Name",
  "City": "City",
  "State/Province": "State/Province",
  "Zip-code": "Zip-code",
  "Country": "Country",
  "Phone number": "Phone number",
  "Please select a country first":"Please select a country first",
  "This field is required": "此字段为必填项。",
  "The field should have at least 2 characters": "The field should have at least 2 characters",
  "The field should have at least 4 characters": "The field should have at least 4 characters",
  "The field should have at least 8 characters": "The field should have at least 8 characters",
  "New Password": "New Password",
  "New Products": "New Products",
  "There are no shipping methods available for this country. We are sorry, please try with different country.": "There are no shipping methods available for this country. We are sorry, please try with different country.",
  "There was some error while trying to fetch shipping methods. We are sorry, please try with different shipping details.": "There was some error while trying to fetch shipping methods. We are sorry, please try with different shipping details.",
  "There was some error while trying to select this shipping method. We are sorry, please try with different shipping method.": "There was some error while trying to select this shipping method. We are sorry, please try with different shipping method.",
  "We can't find products matching the selection.":"We can't find products matching the selection.",
  'Page not found': 'Page not found',
  'Back to Home page': '返回首页',
  'An error occurred': '发生一个错误',
  "AllProductsFromCategory": "All {categoryName}",
  "Portfolio click to expand": "点击展开",
  "Portfolio click to collapse": "点击收起",
  "Yes": "Yes",
  "No": "No",
  "Apply filters": "Apply filters",
  "The coupon code isn't valid. Verify the code and try again.": "The coupon code isn't valid. Verify the code and try again.",
  "From": "From",
  "To": "To",
  "Your customization": "Your customization",
  "Passwords don't match":"Passwords don't match",
  "The password must be at least 8 characters long and must contain at least: 1 uppercase or lowercase letter, 1 number, or one special character (E.g. , . _ & ? etc)":"The password must be at least 8 characters long and must contain at least: 1 uppercase or lowercase letter, 1 number, or one special character (E.g. , . _ & ? etc)",
  "Show all products":"Show all products",
  "Select previously saved address":"Select previously saved address",
  "Enter different address":"Enter different address",
  "You must confirm your account. Please check your email for the confirmation link.": "You must confirm your account. Please check your email for the confirmation link.",
  "Change Store":"Change Store",
  "Choose Currency":"Choose Currency",
  "Add a review":"Add a review",
  "Add to cart":"Add to cart",
  "Title":"Title",
  "Name":"Name",
  "Review":"Review",
  "Add review":"Add review",
  "Are you sure you would like to remove this item from the shopping cart?":"Are you sure you would like to remove this item from the shopping cart?",
  "Your cart is empty":"Your cart is empty",
  "Are you sure?":"Are you sure?",
  "{0} has been successfully removed from your cart":"{0} has been successfully removed from your cart",
  "Amount":"Amount",
  "Thank you for your order!":"Thank you for your order!",
  "Your Purchase":"Your Purchase",
  "Primary contacts for any questions":"Primary contacts for any questions",
  "Your Account":"Your account",
  "What can we improve":"What can we improve",
  "Payment date":"Payment date",
  "The user password was changed successfully updated!":"The user password was changed successfully updated!",
  "The user account data was successfully updated!":"The user account data was successfully updated!",
  "You submitted your review for moderation.": "You submitted your review for moderation.",
  "Starting at": "Starting at",
  "Compare": "Compare",
  "FQA": "FQA",
  "Terms & Conditions": "Terms & Conditions",
  "Contact Us": "联系我们",
  "Hydrogen generation contact us": "氢能制备联系我们",
  "Hydrogen generation": "氢能制备",
  "Get in touch with an expert": "立即联系我们的专家",
  "Tell us about your project, product need, or technical question. A Bekaert specialist will route your inquiry to the right expert.": "告诉我们您的项目、产品需求或技术问题，贝卡尔特专家会将您的咨询转给合适的团队。",
  "Request a quote": "获取报价",
  "Thank you": "谢谢",
  "Thank You for Getting in Touch": "感谢您的联系",
  "Your message has been submitted. We will contact you as soon as possible.": "您的留言已提交，我们会尽快与您联系。",
  "Send another message": "发送另一条留言",
  "Contact our hydrogen generation team": "联系贝卡尔特氢能制备团队",
  "Personal Details": "个人信息",
  "First Name": "名字",
  "Last Name": "姓氏",
  "Business Email": "工作邮箱",
  "Company Information": "公司信息",
  "Company Name": "公司名称",
  "Country/Region": "国家/地区",
  "City": "城市",
  "Zip/Postal Code": "邮政编码",
  "Requested Information": "咨询信息",
  "How can we help?": "我们可以如何帮助您？",
  "General inquiry": "一般咨询",
  "Technical support": "技术支持",
  "Message": "留言",
  "Yes, I would like to receive updates from Bekaert.": "是的，我希望接收贝卡尔特的最新信息。",
  "Bekaert hydrogen generation experts": "贝卡尔特氢能制备专家",
  "Connect with the right specialist": "联系合适的专家",
  "Share your requirements and our team will help you identify the right hydrogen generation solution.": "分享您的需求，我们的团队将帮助您确定合适的氢能制备解决方案。",
  "Share your sample requirements and delivery details. Our local sales team will review your request and respond shortly.": "请填写您的样品需求和交付信息，我们当地销售团队会审核并尽快回复。",
  "Your quote request has been submitted. We will contact you as soon as possible.": "您的报价申请已提交，我们会尽快与您联系。",
  "Request another quote": "再次申请报价",
  "Order samples for hydrogen generation": "申请氢能制备样品",
  "Use this form to request hydrogen generation samples. If your sample is not listed, submit the": "请使用此表单申请氢能制备样品。如未找到所需样品，请提交",
  "contact form": "联系表单",
  "and our local sales team will follow up.": "，我们当地销售团队会跟进。",
  "Product Information": "产品信息",
  "If you have ordered before, note that material codes were updated in 2024. Please check the": "如果您之前订购过样品，请注意物料代码已在 2024 年更新。请查看",
  "updated code list": "更新后的代码列表",
  "Product request": "产品需求",
  "Remove product": "移除产品",
  "Application": "应用",
  "Select application": "选择应用",
  "Please select": "请选择",
  "PEM electrolyzer": "PEM 电解槽",
  "AEM electrolyzer": "AEM 电解槽",
  "Fuel cell": "燃料电池",
  "Other hydrogen application": "其他氢能应用",
  "Product type": "产品类型",
  "Select product type": "选择产品类型",
  "Titanium porous transport layer": "钛多孔传输层",
  "Platinum coated titanium porous transport layer": "铂涂层钛多孔传输层",
  "Nickel porous transport layer": "镍多孔传输层",
  "Stainless steel porous transport layer": "不锈钢多孔传输层",
  "Other product": "其他产品",
  "Material or product code": "物料或产品代码",
  "Select material or product code": "选择物料或产品代码",
  "Product notes": "产品备注",
  "Add another product": "添加另一个产品",
  "Your Message": "您的留言",
  "Phone Number": "电话号码",
  "(Optional)": "（可选）",
  "Work Email": "工作邮箱",
  "Address Line 1": "地址",
  "Address Line 2": "地址行 2",
  "Country": "国家",
  "China": "中国",
  "Postal Code": "邮政编码",
  "I would like to receive communication from Bekaert": "我愿意接收来自贝卡尔特的资讯",
  "Reset form": "重置表格",
  "Submit form": "提交表格",
  "Bekaert, your partner": "贝卡尔特，您的理想合作伙伴",
  "Bekaert's expertise in metal transformation and coatings positions them as an ideal partner for developing durable, efficient components vital for a hydrogen-powered future.": "贝卡尔特在金属变形与镀层领域拥有丰富经验和专业技术，是您开发高效、耐用组件的理想合作伙伴。这些组件，对于驱动氢能未来发展至关重要。",
  "Bekaert's expertise in metal transformation and coatings positions them as an ideal partner for developing durable, efficient components.": "贝卡尔特在金属变形与镀层领域拥有丰富经验和专业技术，是您开发高效、耐用组件的理想合作伙伴。",
  "These components are vital for driving the future development of hydrogen energy.": "这些组件，对于驱动氢能未来发展至关重要。",
  "Request type": "咨询类型",
  "Marketing updates": "营销信息订阅",
  "Yes": "是",
  "No": "否",
  "Source page": "来源页面",
  "The last name is required": "姓氏是必填的",
  "The first name is required": "名字是必填的",
  "The company is required": "公司名称是必填的",
  "The country is required": "国家/地区是必填的",
  "The city is required": "城市是必填的",
  "The postal code is required": "邮政编码是必填的",
  "The last name cannot exceed 50 characters": "姓氏不能超过50个字符",
  "The first name cannot exceed 50 characters": "名字不能超过50个字符",
  "The country cannot exceed 80 characters": "国家/地区不能超过80个字符",
  "The city cannot exceed 80 characters": "城市不能超过80个字符",
  "The postal code cannot exceed 20 characters": "邮政编码不能超过20个字符",
  "The comment cannot exceed 750 characters": "留言不能超过750个字符",
  "The comment cannot exceed 512 characters": "留言不能超过512个字符",
  "The message is required": "留言是必填的",
  "The message cannot exceed 750 characters": "留言不能超过750个字符",
  "The message cannot exceed 512 characters": "留言不能超过512个字符",
  "The application is required": "应用是必填的",
  "The product type is required": "产品类型是必填的",
  "The material code is required": "物料代码是必填的",
  "The quantity is required": "数量是必填的",
  "The material code cannot exceed 80 characters": "物料代码不能超过80个字符",
  "The quantity cannot exceed 20 characters": "数量不能超过20个字符",
  "The product note cannot exceed 200 characters": "产品备注不能超过200个字符",
  "Related Sites": "相关网站",
  "Back to Menu": "返回菜单",
  "Markets": "市场",
  "No matching search results": "没有匹配的内容",
  "Follow us on": "关注我们",
  "Web Privacy Policy": "网络隐私政策",
  "Cookie Policy": "Cookie政策",
  "Sitemap": "站内地图",
  "Site Search": "站点搜索",
  "Search Result": "搜索结果",
  "Results for": "个结果",
  "Load more results": "加载更多",
  "Full Name": "姓名",
  "Job Title": "职位",
  "Phone": "电话",
  "E-mail": "邮箱",
  "Company": "公司名称",
  "Tell us about your inquiry": "询问详情",
  "You have submit successfully": "您已成功提交",
  "Failed to submit": "提交失败",
  "Reset": "重置",
  "Send us your question": "提交您的问题",
  "Validation failed": "验证失败",
  "Verification code expired": "验证码已过期",
  "They're no results for the information you are looking for. Can you enter another term? Or": "您输入的查寻条件未查到结果。请换一个查寻条件？或",
  "if you have any questions": "如果您有任何问题",
  "The name is required": "姓名是必填的",
  "The job is required": "职位是必填的",
  "The phone is required": "电话是必填的",
  "The email is required": "邮箱是必填的",
  "The comment is required": "详情是必填的",
  "The recaptcha is required": "人机身份验证是必填的",
  "The name cannot exceed 50 characters": "姓名不能超过50个字符",
  "The job cannot exceed 50 characters": "职位不能超过50个字符",
  "The phone cannot exceed 20 characters": "电话不能超过20个字符",
  "The email cannot exceed 100 characters": "邮箱不能超过100个字符",
  "The company cannot exceed 50 characters": "公司名称不能超过50个字符",
  "The comment cannot exceed 500 characters": "详情不能超过500个字符",
  "{count} characters left": "还剩{count}个字符",
  "Thank you for your message": "感谢您的留言，我们将尽快按您预留的联系方式与您取得联系。",
  "Oops, this page does not exist": "这个页面不存在",
  "EN": "英语",
  "ZH": "中文",
  "Please enter a correct e-mail address": "请输入正确的电子邮件地址",
  "Please enter a valid telephone number": "请输入有效的电话号码",
  "For more product information or services, please fill out the table below. We will contact you promptly.": "如需了解更多产品信息或服务，请填写下表。我们会及时与您取得联系。",
  "Industry": "行业",
  "News room": "新闻室",
  "Load more": "加载更多",
  "Please enter a valid data": "请输入有效的信息",
  "PDF Viewer": "PDF查看器",
  "Our core competencies": "我们的核心竞争力",
  "Fill out the form to request more information.": "填写表格获取更多信息",
  "Click here to request a price quote.": "点击此处获取报价",
  "Choose Country": "选择国家",
  "We experienced a technical difficulty while processing your request. Your data may not have been correctly saved.": "处理您的请求时遇到技术问题，您的数据可能未正确保存。",
  "Please enter a valid postal code": "请输入有效的邮政编码",
  "Register to our newsletter": "订阅我们的新闻资讯",
  "Stay up to date with the latest hydrogen generation insights and news from Bekaert.": "想第一时间掌握氢能技术的最新动态与行业趋势？欢迎订阅月度资讯，加入社群，共同推动绿色能源的未来。",
  "Thank you for subscribing to our newsletter": "感谢您订阅我们的新闻简报",
  "Hydrogen leads newsletter data submitted successfully.": "氢能新闻简报订阅信息已成功提交。",
  "Newsletter subscription request timed out. Please try again later.": "新闻简报订阅请求超时，请稍后重试。",
  "This form allows you to order samples. If the sample you're looking for isn't listed, please fill out the": "此表单用于样品订购。如您所需的样品未在列表中列出，请填写",
  "and our local sales team will be in touch.": "，我们的本地销售团队会及时与您接洽。",
  "Add a new product": "添加新产品",
  "Ordered with us before, but can\'t find what you\'re looking for? Our material codes were updated in 2024. Please check the": "之前订购过，但找不到您需要的产品吗？我们的物料代码已在2024年更新。请查看",
  "Material": "材料",
  "Surface area": "表面积",
  "Thickness (mm / inch)": "厚度（毫米/英寸）",
  "Porosity %": "孔隙率 %",
  "Product size": "产品尺寸",
  "Quantity": "数量",
  "Delete": "删除",
  "The address is required": "地址是必填的",
  "We've Received Your Inquiry and Will Respond Shortly": "我们已收到您的咨询，并将尽快回复您",
  "By subscribing, you agree to receive our newsletters and acknowledge that your data will be processed as outlined in our": "查阅我们的",
  "By subscribing, you agree to receive our newsletters and acknowledge that your data will be processed as outlined in our Privacy Policy": "查阅我们的隐私政策，了解数据处理方式。您可随时取消订阅。",
  "newsletter privacy policy notice suffix": "，了解数据处理方式。您可随时取消订阅。",
};
